import { render, staticRenderFns } from "./ItemType.vue?vue&type=template&id=6aca6744"
import script from "./ItemType.vue?vue&type=script&lang=ts"
export * from "./ItemType.vue?vue&type=script&lang=ts"
import style0 from "./ItemType.vue?vue&type=style&index=0&id=6aca6744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports